<template>
  <v-container v-if="personal">
    <v-row>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Clave única de Registro de Población</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="curpForm" ref="curp">
              <BaseInput
                v-model="personal.curp"
                :rules="curpRules"
                maxlength="18"
                counter="18"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>CURP <span class="red--text">*</span> </template>
              </BaseInput>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Cartilla militar</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="smnForm" ref="smn">
              <BaseInput
                v-model="personal.cartillaMilitar"
                :rules="personal.fk_idSexo == 1 ? required : []"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label
                  >Cartilla militar <span class="red--text" v-if="personal.fk_idSexo == 1">*</span>
                </template>
              </BaseInput>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Clave de elector (INE)</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="ineForm" ref="ine">
              <BaseInput
                v-model="personal.claveIne"
                :rules="ineRules"
                maxlength="18"
                counter="18"
                :readonly="perfil === PERFILES['Administrador IPH+'] && true"
              >
                <template #label>Clave de credencial de elector (INE) <span class="red--text">*</span> </template>
              </BaseInput>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Número de Seguro Social</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.nss"
              label="Número de seguro social"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Pasaporte</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.pasaporte"
              label="Pasaporte"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
          <v-col cols="12">
            <BaseInput
              v-model="personal.vigenciaPasaporte"
              label="Vigencia de pasaporte"
              v-mask="'##/##/####'"
              :rules="vigenciaRules"
              hint="Formato de fecha: DD/MM/YYYY"
              :disabled="personal.pasaporte === ''"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            >
            </BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">VISA</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.visa"
              label="Visa"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
          <v-col cols="12">
            <BaseInput
              v-model="personal.vigenciaVisa"
              label="Vigencia de visa"
              v-mask="'##/##/####'"
              :rules="vigenciaRules"
              hint="Formato de fecha: DD/MM/YYYY"
              :disabled="personal.visa === ''"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            >
            </BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Número de Registro Federal de Contribuyentes</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.rfc"
              :rules="required"
              label="RFC"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Licencia para conducir</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.licenciaConducir"
              label="Licencia para conducir"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
            <BaseInput
              v-model="personal.vigenciaLicencia"
              label="Vigencia de licencia"
              v-mask="'##/##/####'"
              :rules="vigenciaRules"
              hint="Formato de fecha: DD/MM/YYYY"
              :disabled="personal.licenciaConducir === ''"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            >
            </BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="personal.fk_idEstatus == 1">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8" v-if="personal.fk_idEstatus == 1">
        <div class="text-h6 font-weight-bold">CUIP</div>
      </v-col>
      <v-col cols="4" v-if="personal.fk_idEstatus == 1">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.CUIP"
              label="CUIP"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="personal.fk_idEstatus == 1">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8" v-if="personal.fk_idEstatus == 1">
        <div class="text-h6 font-weight-bold">CUP</div>
      </v-col>
      <v-col cols="4" v-if="personal.fk_idEstatus == 1">
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.CUP"
              label="CUP"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="personal.fk_idEstatus == 1">
        <v-divider></v-divider>
      </v-col>
      <v-col
        cols="8"
        v-if="
          personal.fk_idEstatus == 1 &&
          perfil !== PERFILES['Enlace C3'] &&
          perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']
        "
      >
        <div class="text-h6 font-weight-bold">NCP</div>
      </v-col>
      <v-col
        cols="4"
        v-if="
          personal.fk_idEstatus == 1 &&
          perfil !== PERFILES['Enlace C3'] &&
          perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']
        "
      >
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.ncp"
              label="NCP"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        v-if="
          personal.fk_idEstatus == 1 &&
          perfil !== PERFILES['Enlace C3'] &&
          perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']
        "
      >
        <v-divider></v-divider>
      </v-col>
      <v-col
        cols="8"
        v-if="
          personal.fk_idEstatus == 1 &&
          perfil !== PERFILES['Enlace C3'] &&
          perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']
        "
      >
        <div class="text-h6 font-weight-bold">Número de servicio médico interno</div>
      </v-col>
      <v-col
        cols="4"
        v-if="
          personal.fk_idEstatus == 1 &&
          perfil !== PERFILES['Enlace C3'] &&
          perfil !== PERFILES['ENLACE C3_ADMINISTRADOR'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'] &&
          perfil !== PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']
        "
      >
        <v-row>
          <v-col cols="12">
            <BaseInput
              v-model="personal.nsmi"
              label="Número de servicio médico interno"
              :readonly="perfil === PERFILES['Administrador IPH+'] && true"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import BaseInput from '../../../base/BaseInput.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    BaseInput,
  },
  data() {
    return {
      PERFILES,
      curpForm: false,
      smnForm: false,
      ineForm: false,
      nssForm: false,
      pasaporteForm: false,
      visaForm: false,
      rfcForm: false,
      licenciaConducirForm: false,
      cuipForm: false,
      cupForm: false,
      ncpForm: false,
      nsmiForm: false,
      required: [(v) => !!v || 'Este campo es obligatorio'],
      vigenciaRules: [
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
      curpRules: [(v) => !!v || 'Este campo es requerido.', (v) => v.length == 18 || 'Ingrese CURP a 18 dígitos.'],
      ineRules: [(v) => !!v || 'Este campo es requerido.', (v) => v.length == 18 || 'Ingrese INE a 18 dígitos.'],
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
  },
  methods: {
    ...mapActions('personal', ['updatePersonal']),
    guardar() {
      this.updatePersonal(this.personal)
      this.$emit('updated')
    },
  },
}
</script>
